import React, { useEffect, useState } from 'react'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import TutorFooter from '../../TutorFooter/TutorFooter'
import { Link, useNavigate } from 'react-router-dom'
import TutorHeader from '../../TutorHeader/TutorHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getTutorMyBookedScheduleGroupListData, getTutorMyBookedScheduleOneListData } from '../../../../Redux/action/TutorAction'
import Beatloader from '../../../../Common/BeatLoader'
import { doc, collection, getDoc, setDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firbase";
import { getProfileData } from '../../../../Redux/action/MasterAction'
import toast from 'react-hot-toast'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
const host = process.env.REACT_APP_API_SERVER
const TutorBookedSchedules = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(getTutorMyBookedScheduleGroupListData())
        dispatch(getTutorMyBookedScheduleOneListData())

    }, []);

    const {
        loadingTutorMyBookedScheduleOneListApi,
        TutorMyBookedScheduleOneListApiData,
        TutorMyBookedScheduleOneListApiError,

        loadingTutorMyBookedScheduleGroupListApi,
        TutorMyBookedScheduleGroupListApiData,
        TutorMyBookedScheduleGroupListApiError
    } = useSelector(state => state?.TutorReducer);




    const handleChatNavigation = async (id) => {
        try {
            const authToken = localStorage.getItem('tutor-token');
            const decoded = jwtDecode(authToken);
            const participant1 = decoded?.user?.id;
            const participant2 = id;


            if (!participant1 || !participant2) {
                toast.error("Invalid participant IDs. Unable to navigate to chat.");
                return;
            }

            const data = { participant1, participant2 };
            console.log('decoded',decoded?.user)
            console.log('participangs',data)

            const response = await axios.post(`${host}/api/web/create-chatroom`, data, {
                headers: {
                    "x-auth-token": authToken,
                },
            });

            if (response.data?.statusCode === 200) {
                const chatroomId = response.data.data.chatroomId;
                navigate(`/tutor/chat/${btoa(chatroomId)}`);
            } else {
                toast.error(response.data?.message || "Failed to create chatroom!");
            }
        } catch (error) {
            console.error("Error navigating to chat:", error);
            toast.error("An error occurred while creating the chatroom. Please try again!");
        }
    };
    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Booked Sessions
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                One To One
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                Group Tutoring
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingTutorMyBookedScheduleOneListApi ?
                                                <Beatloader />
                                                :
                                                <div className="table-responsive">
                                                    <table className="table table-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Subject</th>
                                                                <th scope="col">Course Name</th>
                                                                <th scope="col">Start date</th>
                                                                <th scope="col">Start Time</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TutorMyBookedScheduleOneListApiData?.length > 0 ?
                                                                TutorMyBookedScheduleOneListApiData?.map((data, index) => (
                                                                    <tr>
                                                                        <th>{index + 1}</th>
                                                                        <td>
                                                                            <div>
                                                                                {/* <span className="table-img">
                                                                                    <img
                                                                                        src="/assets/img/user/user1.jpg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </span> */}
                                                                                <span className="ms-2">{data?.student?.name}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td>{data?.course?.subcategory?.name}</td>
                                                                        <td>{data?.course?.name}</td>
                                                                        <td>{data?.course?.start_date}</td>
                                                                        <td>{data?.course?.start_time}</td>
                                                                        <td>
                                                                            <div>
                                                                                <span>
                                                                                    <a onClick={() => { handleChatNavigation(data?.student?.id) }} className="chat-link">
                                                                                        <i
                                                                                            className="fa-solid fa-comment"
                                                                                            data-toggle="tooltip"
                                                                                            title="chat"
                                                                                        />
                                                                                    </a>
                                                                                </span>
                                                                                <span className="ms-2">
                                                                                    <Link
                                                                                        to={`/tutor/my-schedule-one-to-one-details/${btoa(data?.id)}`}
                                                                                        className="view-link"
                                                                                    >
                                                                                        <i
                                                                                            className="fa-solid fa-eye"
                                                                                            data-toggle="tooltip"
                                                                                            title="view schedule"
                                                                                        />
                                                                                    </Link>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                                :
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">No Data</th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            {loadingTutorMyBookedScheduleGroupListApi ?
                                                <Beatloader />
                                                :
                                                <div className="table-responsive">
                                                    <table className="table table-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Subject</th>
                                                                <th scope="col">Course Name</th>
                                                                <th scope="col">Start date</th>
                                                                <th scope="col">Start Time</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TutorMyBookedScheduleGroupListApiData?.length > 0 ?
                                                                TutorMyBookedScheduleGroupListApiData?.map((data, index) => (
                                                                    <tr>
                                                                        <th>{index + 1}</th>
                                                                        <td>
                                                                            <div>
                                                                                {/* <span className="table-img">
                                                                                    <img
                                                                                        src="/assets/img/user/user1.jpg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </span> */}
                                                                                <span className="ms-2">{data?.student?.name}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td>{data?.course?.subcategory?.name}</td>
                                                                        <td>{data?.course?.name}</td>
                                                                        <td>{data?.course?.batches?.batch_start_date}</td>
                                                                        <td>{data?.course?.batches?.batch_start_time}</td>
                                                                        <td>
                                                                            <div>
                                                                                <span>
                                                                                    <a onClick={() => { handleChatNavigation(data?.student?.id) }} className="chat-link">
                                                                                        <i
                                                                                            className="fa-solid fa-comment"
                                                                                            data-toggle="tooltip"
                                                                                            title="chat"
                                                                                        />
                                                                                    </a>
                                                                                </span>
                                                                                <span className="ms-2">
                                                                                    <Link
                                                                                        to={`/tutor/my-schedule-group-details/${btoa(data?.id)}`}
                                                                                        className="view-link"
                                                                                    >
                                                                                        <i
                                                                                            className="fa-solid fa-eye"
                                                                                            data-toggle="tooltip"
                                                                                            title="view schedule"
                                                                                        />
                                                                                    </Link>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                                :
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">No Data</th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            }


                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorBookedSchedules